/**
 * orga-app-api - incidents-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IncidentsRolleBerechtigungenRequest { 
    darf_verantwortung_bei_anlegen?: boolean;
    darf_delegation_bei_anlegen?: boolean;
    rolle_id: string;
    funktionsbereich_id: string;
}

